import { Calendar } from '../Calendar'
import { BasicFormItem, BasicFormItemProps } from './BasicFormItem'

export const FormCalendar = (
  props: Omit<BasicFormItemProps, 'component'> & { maxDate: Date },
) => <BasicFormItem component={Calendar} {...props} />
